import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren,
    ViewEncapsulation,
} from "@angular/core";
import { Reminders } from "../../case";
import { CasesService } from "../../cases.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { MatTableDataSource } from "@angular/material/table";
import { fuseAnimations } from "@fuse/animations";
import { ApiService } from "app/main/module/common/service/api.service";
import { NavigationEnd, Router } from "@angular/router";
import { DataService } from "../shared.service";
import * as moment from "moment";
import { MatDialog } from "@angular/material/dialog";
import { ReminderDialogComponent } from "../reminder-dialog/reminder-dialog.component";
import { ReminderRefreshService } from "../../reminderRefresh.service";
import { TimestampService } from "app/main/module/common/timeConstant.service";
import { Subscription } from "rxjs";

@Component({
    selector: "app-reminder-history",
    templateUrl: "./reminder-history.component.html",
    styleUrls: ["./reminder-history.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class ReminderHistoryComponent
    implements OnInit, OnDestroy, AfterViewInit
{
    viewReminder: Reminders[] = [];
    displayedColumns = [];
    columns: any[] = [];
    allData: any[] = [];
    dataSource = new MatTableDataSource<any>(this.allData);
    dataSourceFilters = new MatTableDataSource(this.allData);
    dataSourceWithPageSize = new MatTableDataSource(this.allData);
    page: number;
    isInitComplete: Boolean = false;
    labTimeZone: any;
    userName: any;
    perPage: number;
    totalPage: Boolean = false;
    isNextPressed: Boolean = false;
    count: number = 0;
    next: number = 0;
    prev: number = 0;
    hasMoreData: boolean = true;
    PAGE_SIZE: number = 10;
    private observer: MutationObserver | null = null;
    overflowFlags: boolean[] = [];
    @ViewChildren("cellContent") cellContents!: QueryList<ElementRef>;
    searchText: string = "";
    selectedStatus: string = "";
    statusList = ["yetToReceive", "yetToBook", "Completed"];
    detailPagePath = "/cases/reminder-history/details";
    currentPagePath = "/cases/reminder-history";
    routerSubscription: Subscription;
    searchDisabled: boolean = false;

    constructor(
        public caseService: CasesService,
        public snackbar: MatSnackBar,
        public translate: TranslateService,
        public apiService: ApiService,
        private router: Router,
        private dialog: MatDialog,
        private reminderRefreshService: ReminderRefreshService,
        private timeStampService: TimestampService,
        private el: ElementRef,
        private cdr: ChangeDetectorRef,
    ) {
        this.selectedStatus =
            localStorage.getItem("selectedReminderStatus") || "all";
    }

    ngOnInit(): void {
        this.isInitComplete = true;
        this.labTimeZone = localStorage.getItem("defaultTz");
        this.userName = localStorage.getItem("name");
        this.prev = 0;
        this.next = 1;
        this.page = 0;
        this.count = 1;
        this.perPage = 10;
        this.selectedStatus =
            localStorage.getItem("selectedReminderStatus") || "all";
        this.getReminderHistory(1);
        const keys = [
            "Common.Sr",
            "Reminders.taskName",
            "Reminders.type",
            "Reminders.scheduleDateTime",
            "Reminders.dueDateTime",
            "Reminders.updatedOn",
            "Reminders.updatedBy",
            "Reminders.status",
            "Reminders.action",
        ];
        this.translate.onLangChange.subscribe(() => {
            this.translate.get(keys).subscribe((translations) => {
                this.columns = this.getColumn(translations);
                this.displayedColumns = this.columns.map((c) => c.columnDef);
            });
        });

        this.translate.get(keys).subscribe((translations) => {
            this.columns = this.getColumn(translations);
            this.displayedColumns = this.columns.map((c) => c.columnDef);
        });

        this.routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (
                    !event.url.includes(this.detailPagePath) &&
                    !event.url.includes(this.currentPagePath)
                ) {
                    localStorage.removeItem("selectedReminderStatus");
                }
            }
        });

        this.reminderRefreshService.refresh$.subscribe(() => {
            this.reloadTable();
        });

        this.page = 0;
    }

    getReminderHistory(page: Number, searchText?: string) {
        this.isInitComplete = true;
        this.totalPage = false;
        this.perPage = 10;
        this.caseService
            .getReminderHistory(
                page,
                this.perPage,
                searchText,
                this.selectedStatus,
            )
            .subscribe(
                (res: any) => {
                    if (res.message == "No data Found") {
                        this.totalPage = true;
                        this.isInitComplete = true;
                        this.searchDisabled = false;
                    }
                    if (res && res.data.length > 0) {
                        this.viewReminder = res.data;
                        this.allData.push(...this.viewReminder);
                        this.dataSource.data = this.allData;
                        this.isInitComplete = false;
                        this.searchDisabled = false;
                        this.hasMoreData =
                            this.viewReminder.length === this.PAGE_SIZE;
                        if (!this.hasMoreData && this.isNextPressed) {
                            this.openSnackBar(
                                this.translateSentence(
                                    "Common.noFurtherDataAvailable",
                                ),
                                this.translateSentence("Common.ok"),
                            );
                        }
                    } else {
                        this.viewReminder = [];
                        this.isInitComplete = false;
                        this.openSnackBar(
                            this.translateSentence("Common.noDataFound"),
                            this.translateSentence("Common.ok"),
                        );
                    }
                },
                (error) => {
                    console.error("Error fetching cases:", error);
                    this.isInitComplete = false;
                    let errorMessage = error.error.message;
                    this.openSnackBar(
                        errorMessage,
                        this.translateSentence("Common.ok"),
                    );
                },
            );
    }

    getColumn(translations: { [key: string]: string }): any[] {
        return [
            {
                columnDef: "SrReminder",
                header: translations["Common.Sr"],
                cell: (element: Reminders, index: number) =>
                    `${this.page * 10 + index + 1}`,
            },
            {
                columnDef: "taskName",
                header: translations["Reminders.taskName"],
                cell: (element: Reminders, index: number) => element.task_name,
            },
            {
                columnDef: "scheduledDateTime",
                header: translations["Reminders.scheduleDateTime"],
                cell: (element: Reminders, index: number) =>
                    this.changeDate(element.schedule_epoch_timestamp),
            },
            {
                columnDef: "dueDateTime",
                header: translations["Reminders.dueDateTime"],
                cell: (element: Reminders, index: number) =>
                    this.changeDate(element.next_due_date),
            },
            {
                columnDef: "updatedOn",
                header: translations["Reminders.updatedOn"],
                cell: (element: Reminders, index: number) =>
                    this.changeDate(element.updated_on),
            },
            {
                columnDef: "updatedBy",
                header: translations["Reminders.updatedBy"],
                cell: (element: Reminders, index: number) => element.updated_by,
            },
            {
                columnDef: "status",
                header: translations["Reminders.status"],
                cell: (element: Reminders, index: number) => {
                    let status = element.status;
                    status === "Pending"
                        ? (status = "yetToReceive")
                        : status === "Received"
                          ? (status = "yetToBook")
                          : (status = element.status);
                    return this.translateSentence(`Status.${status}`);
                },
            },
            {
                columnDef: "details",
                header: translations["Reminders.action"],
                cell: (element: Reminders, index: number) => {
                    element.id;
                },
            },
        ];
    }

    openSnackBar(message: string, action: string): void {
        // this.isLoading = true;
        // this.hasFirstDataShown = true;
        this.snackbar.open(message, action, {
            duration: 1000,
        });
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }

    getRowBackgroundColor(element): string {
        return "#FFFFFF";
    }

    getRowFontStyle(element) {
        if (element.status == "completed") {
            return "italic";
        } else return "bold";
    }

    getFontColor(element) {
        if (element.status == "completed") {
            return "#808080";
        } else return "#000000";
    }

    ngAfterViewInit(): void {
        const table: HTMLElement | null =
            this.el.nativeElement.querySelector("mat-table");
        if (!table) return;

        this.observer = new MutationObserver((mutations) => {
            if (!this.isNextPressed) return;

            const rows = table.querySelectorAll(".mat-row");
            if (rows.length > 0) {
                const last = rows[rows.length - 1] as HTMLElement;
                last.scrollIntoView({ behavior: "smooth", block: "end" });
                this.isNextPressed = false;
            }
        });

        this.observer.observe(table, { childList: true, subtree: true });
        this.updateOverflowFlags();

        this.cellContents.changes.subscribe(() => this.updateOverflowFlags());
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private updateOverflowFlags(): void {
        this.overflowFlags = this.cellContents.map((el) =>
            this.isTextOverflowing(el.nativeElement),
        );
        this.cdr.detectChanges();
    }

    isTextOverflowing(element: HTMLElement): boolean {
        return element.scrollWidth > element.clientWidth;
    }

    changeDate(date): any {
        // // // console.log(e);
        var timestamp = parseInt(date);
        return (date = this.apiService.getDateStringMomentByTz(timestamp));
    }

    viewReminderDetails(id) {
        this.router.navigate(["/cases/reminder-history/details"], {
            queryParams: { reminder_id: id },
        });
    }

    openReminderDialogBox(reminder: any) {
        const dialogRef = this.dialog.open(ReminderDialogComponent, {
            disableClose: true,
            width: "450px",
            height: "auto",
            data: { data: reminder, openWithButton: true },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result?.action === "updated") {
                this.reminderRefreshService.triggerRefresh();
            }
        });
    }

    reloadTable() {
        this.allData = [];
        this.dataSource.data = [];
        this.viewReminder = [];
        this.hasMoreData = true;
        this.isNextPressed = false;
        this.searchDisabled = false;
        this.prev = 0;
        this.next = 1;
        this.page = 0;
        this.count = 1;
        this.perPage = 10;
        this.selectedStatus = "all";
        localStorage.setItem("selectedCaseStatus", "all");
        this.getReminderHistory(1);
    }

    onNextPress() {
        this.isInitComplete = true;
        this.isNextPressed = true;
        this.count = this.count + 1;
        this.next = this.prev + 1;
        this.prev = this.next - 1;
        this.next++;
        this.prev++;
        this.getReminderHistory(this.next, this.searchText);
    }

    handleSearchReminder(searchText: string) {
        if (!searchText || !searchText.trim()) {
            this.openSnackBar(
                this.translateSentence("Common.noSearchValueAvailable"),
                this.translateSentence("Common.ok"),
            );
            return;
        }
        this.searchText = searchText.trim();
        this.allData = [];
        this.dataSource.data = [];
        this.viewReminder = [];
        this.hasMoreData = true;
        this.isNextPressed = false;
        this.searchDisabled = true;
        this.prev = 0;
        this.next = 1;
        this.page = 0;
        this.count = 1;
        this.perPage = 10;
        this.selectedStatus = "all";
        localStorage.setItem("selectedReminderStatus", "all");
        this.getReminderHistory(1, this.searchText);
    }

    refreshSearch(event) {
        if (event.code === "Backspace" && this.searchText.length === 1) {
            this.searchText = "";
            this.reloadTable();
        }
    }

    clearInputSearch() {
        this.searchText = "";
        localStorage.setItem("selectedReminderStatus", "all");
        this.reloadTable();
    }

    filterReminderByStatus() {
        this.dataSource.data = [];
        this.allData = [];
        this.viewReminder = [];
        this.searchText = "";
        this.searchDisabled = false;
        this.next = 1;
        this.page = 0;
        this.prev = 0;
        this.count = 1;
        this.hasMoreData = true;
        this.isNextPressed = false;
        localStorage.setItem("selectedReminderStatus", this.selectedStatus);
        this.getReminderHistory(this.next);
    }
}
